import classNames from 'classnames/bind';

import styles from './TimelineItem.pcss';

const cx = classNames.bind(styles);

interface TimelineItemProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  dataTestId?: string;
}

const TimelineItem = ({ title = null, children = null, dataTestId = '' }: TimelineItemProps): React.ReactElement => (
  <div className={cx('text-neutral-950-opacity-80 last:pb-0', children ? 'pb-4' : 'pb-2')} data-test-id={dataTestId}>
    <div className="mb-1">{title}</div>
    {children ? <div className={cx('content')}>{children}</div> : null}
  </div>
);

export default TimelineItem;
